import { forwardRef } from "react";
import { Filter24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Button, ButtonProps } from "@kaltura/ds-react-components";

/**
 * A button for opening the modal window with the filters.
 * The component doesn't contain the modal itself (see FilterBarButtonWithModal).
 */
export const FilterBarOpenButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
    <Button
        ref={ref}
        startIcon={<Filter24Icon />}
        variant={"borderless"}
        color={"secondary"}
        aria-label={translate("open filters in a modal window")}
        {...props}
    >
        {translate("Filters")}
    </Button>
));
